module.exports = {
  // JCRing成员页 西班牙语言包
  JCRing_member: {
    index1: "Salud de los miembros",
    index2: "Grupos de salud",
    index3: "Miembros",
    index4: "Añadir grupo",
    index5: "Grupos unidos",
    index6: "Configuración de alertas",
    index7: "Permita que quienes se preocupan por su salud se preocupen más por usted a distancia, con cuidado oportuno",
    index8: "Aún no ha unido a ningún grupo",
    index9: "Centro de mensajes",
    index10: "Invitar a unirse a través de / teléfono / correo electrónico / código QR / WeChat",
    
    
    addgroup1: "Nombre del grupo",
    addgroup2: "Tipo de grupo",
    addgroup3: "Por favor, ingrese el nombre del grupo",
    addgroup4: "Grupo familiar",
    addgroup5: "Grupo de empresa",
    addgroup6: "Otro grupo",
    addgroup7: "Grupo médico",
    addgroup8: "Grupo escolar",
    addgroup9: "Confirmar",
    addgroup10: "Cancelar",
    addgroup11: "Crear ahora",
    addgroup12: "El nombre del grupo ya existe",
    
    
    memberlist1: "Lista de miembros",
    memberlist2: "Tiene",
    memberlist3: "Excepciones",
    memberlist4: "Normal",
    memberlist5: "Añadir miembro",
    memberlist6: "Disolver",
    memberlist7: "Sin miembros",
    memberlist8: "Cargando...",
    memberlist9: "¿Disolver este grupo?",
    memberlist10: "Disuelto con éxito",
    memberlist11: "Guardado con éxito",
    memberlist12: "Modificar información del grupo",
    memberlist13: "Disolver grupo",
    memberlist14: "Visión general de la salud",
    memberlist15: "Elementos normales",
    memberlist16: "Elementos anómalos",
    memberlist17: "Haga clic para ver",
    memberlist18: "Sin datos de ayer",
    memberlist19: "Ayer",
    memberlist20: "Enviado",
    memberlist21: "Invitaciones al grupo enviadas, pendiente de confirmación",
    
    
    updatemember1: "Foto de perfil",
    updatemember2: "Cambiar",
    updatemember3: "Apodo original",
    updatemember4: "Modificar apodo",
    
    
    healthdata1: "datos de salud",
    healthdata2: "datos de salud",
    healthdata3: "Domingo",
    healthdata4: "Lunes",
    healthdata5: "Martes",
    healthdata6: "Miércoles",
    healthdata7: "Jueves",
    healthdata8: "Viernes",
    healthdata9: "Sábado",
    healthdata10: "Frecuencia cardíaca",
    healthdata11: "Variabilidad de la frecuencia cardíaca",
    healthdata12: "Presión sistólica",
    healthdata13: "Presión diastólica",
    healthdata14: "Variabilidad de la temperatura",
    healthdata15: "Saturación de oxígeno en sangre",
    healthdata16: "Sueño",
    healthdata17: "Estrés",
    healthdata18: "Colesterol",
    healthdata19: "Triglicéridos",
    healthdata20: "Colesterol LDL",
    healthdata21: "Colesterol HDL",
    healthdata22: "Glucosa en sangre",
    healthdata23: "Antes de las comidas",
    healthdata24: "Después de las comidas",
    healthdata25: "Consumo máximo de oxígeno",
    healthdata26: "Respiración",
    healthdata27: "Pasos",
    healthdata28: "Paso",
    healthdata29: "Calorías",
    healthdata30: "kcal",
    healthdata31: "Distancia",
    healthdata32: "Kilómetros",
    healthdata33: "Ritmo",
    healthdata35: "Segundos/km",
    healthdata36: "Minutos",
    healthdata37: "Cargando datos de salud",
    healthdata38: "Datos de ejercicio",
    healthdata39: "Alertas",
    healthdata40: "No autorizado",
    healthdata41: "Modificar información del miembro",
    healthdata42: "Eliminar miembro",
    healthdata43: "Correo electrónico:",
    healthdata44: "Teléfono:",
    healthdata45: "¿Eliminar a este miembro?",
    healthdata46: "Las fechas futuras no se pueden mostrar",
    healthdata47: "Hoy",
    
    
    
    addmember1: "Invitar miembros",
    addmember2: "Agregar cuenta de miembro",
    addmember4: "Usando 'Cuentas de miembros', puedes ver los datos de salud de los miembros y establecer rangos de datos de alerta para un mejor monitoreo de su salud",
    addmember5: "Más información",
    addmember6: "Miembros del grupo de salud",
    addmember7: "Invitar",
    addmember8: "Unirse",
    addmember9: "Invitar escaneando el código QR",
    addmember10: "Invitación por WeChat",
    addmember11: "Invitar a unirse al grupo escaneando el código QR",
    addmember12: "Invitar a unirse al grupo a través de WeChat",
    addmember13: "Invitación por teléfono/correo electrónico",
    addmember14: "Invitar a unirse al grupo por teléfono/correo electrónico",
    addmember15: "Invita a los miembros a unirse para ver su estado de salud",
    addmember16: "Enviar invitación",
    addmember17: "Enviado",
    addmember18: "Pendiente de confirmación",
    addmember19: "Ya he unido",
    addmember20: "Compartir ahora",
    addmember21: "Guardar imagen",
    addmember22: "He rechazado",
    addmember23: "He salido",
    addmember24: "El miembro ha salido",
    addmember25: "El miembro ha rechazado",
    addmember26: "El miembro se ha unido",
    addmember27: "Otros métodos de adición",
    
    
    code1: "Código QR del grupo",
    code2: "Grupo de gestión de salud",
    code3: "Este código QR es válido por 5 minutos. Por favor, úselo pronto.",
    
    
    invide1: "Invitación al grupo",
    invide2: "Salud de los miembros",
    invide3: "Te invita a unirte al grupo...",
    invide4: "Unirse a este grupo",
    invide5: "Para la seguridad de tus datos, se recomienda revisar la información del grupo antes de unirte.",
    invide6: "Después de unirte al grupo, autorizarás a los seguidores a ver tus datos de salud.",
    
    
    sethealthdata1: "Configuración de datos de salud",
    sethealthdata2: "Confirmar",
    sethealthdata3: "Por favor, configura un apodo",
    sethealthdata4: "Permitir todo",
    sethealthdata5: "Configura un apodo",
    sethealthdata6: "Guardar",
    sethealthdata7: "Por favor, ingresa",
    sethealthdata8: "Por favor, sube en formato de imagen",
    sethealthdata9: "Por favor, configura tanto el apodo como el avatar",
    sethealthdata10: "Por favor, configura un avatar",
    sethealthdata11: "La longitud del apodo debe ser de 1 a 8 caracteres",
    
    
    setscope1: "Rango de frecuencia cardíaca",
    setscope2: "Rango de temperatura",
    setscope3: "Rango de sueño",
    setscope4: "Rango de frecuencia cardíaca fetal",
    setscope5: "Glucosa en sangre antes de las comidas",
    setscope6: "Glucosa en sangre después de las comidas",
    setscope7: "Rango de oxígeno en sangre",
    setscope8: "Ácido úrico masculino",
    setscope9: "Ácido úrico femenino",
    setscope10: "Presión sistólica",
    setscope11: "Presión diastólica",
    setscope12: "Límite superior",
    setscope13: "Límite inferior",
    setscope14: "Configuración de alertas",
    setscope15: "Configuración guardada",
    setscope16: "Límite superior",
    setscope17: "Límite inferior",
    setscope18: "Alerta",
    
    
    onload1: "Haga clic",
    onload2: "Unirse al grupo de salud",
    onload3: "Por favor, abra en el navegador",
    onload4: "Entendido",
    onload5: "Youhong Salud, Salud inteligente cada día",
    onload6: "Descargar gratis desde App Store",
    onload7: "Descargar gratis",
    onload8: "Enlace expirado",
    onload9: "Código QR expirado",
    onload10: "Unido con éxito",
    
    
    // invide1: "Invitación al grupo",
    // invide2: "Salud de los miembros",
    // invide3: "Te invita a unirte al grupo...",
    // invide4: "Unirse a este grupo",
    // invide5: "Para la seguridad de tus datos, se recomienda revisar la información del grupo antes de unirte.",
    // invide6: "Después de unirte al grupo, autorizarás a los seguidores a ver tus datos de salud.",
    
    
    guide1: "Después de ingresar a la salud de los miembros, debe crear primero el tipo de grupo correspondiente.",
    guide2: "Después de crear el grupo, ingrese al grupo para ver el resumen de salud de los usuarios e invitar a nuevos miembros.",
    guide3: "Para invitar a nuevos miembros al grupo, puede usar métodos como escanear un código QR, WeChat, número de teléfono/correo electrónico. Después de que los nuevos miembros se unan al grupo, puede ver sus actualizaciones diarias de salud.",
    guide4: "Haga clic para ver el resumen de salud, donde puede ver los datos de salud de los miembros y determinar las condiciones normales o anormales.",
    guide5: "Siguiente",
    guide6: "Finalizar",
    guide7: "Supera el valor de advertencia",
    
    invite1: "Invitar por número de teléfono/correo electrónico",
    invite2: "Por favor ingrese la cuenta",
    invite3: "Por favor ingrese el número de teléfono",
    invite4: "Por favor ingrese el correo electrónico",
    invite5: "Por favor ingrese un número de teléfono válido",
    invite6: "Por favor ingrese un correo electrónico válido",
    invite7: "Ya se unió a este grupo",
    invite8: "El usuario no existe",
    invite9: "Seleccione país o región",
    invite10: "Por favor ingrese palabras clave de búsqueda",
    invite11: "Confirmar usuario",
    invite12: "Invitarlo",
    invite13: "Por favor seleccione",
  }
};



// WEBPACK FOOTER //
// ./src/lang/es.js